import { ISvgProps } from '@src/types';

const PenIcon = ({ width = '22px', height = '22px', fillColor = 'var(--font-color)', ...props }: ISvgProps) => {
  return (
    <svg
      width={width}
      height={height}
      {...props}
      viewBox="0 0 22 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M16.8410738,0.103929647 C16.7516744,0.252530254 1.28535205,15.5457527 1.27294185,15.7319516 C1.27271203,15.7323193 0.0169380361,19.921358 0.0169380361,19.921358 C0.00944595445,19.9447995 0.00452783953,19.9686547 0.00199983653,19.9927396 C-0.0114215612,20.1164279 0.0434590857,20.2408976 0.144165532,20.3151749 L0.144441315,20.3151749 C7.40642869,25.4729443 14.4972932,13.5221094 21.3913872,20.2804723 C21.7194761,20.5996442 22.220848,20.126448 21.8934027,19.7785488 C15.0139711,12.8275521 8.31591224,23.7076169 1.20817901,20.1440061 L4.65214644,19.1115697 C4.85659294,19.0841754 20.1192961,3.64340948 20.2807666,3.54320864 C20.4192552,3.40481197 20.4192552,3.18018743 20.2804448,3.04165287 C20.2804448,3.04165287 17.3428594,0.103975611 17.3428594,0.103975611 C17.2043248,-0.0346508753 16.9796543,-0.0346508753 16.8410738,0.103929647 Z M2.91049027,15.0380378 L5.34633606,17.4739295 L4.36262115,18.4576903 L0.883813246,19.5004685 L1.92672939,16.0217986 L2.91049027,15.0380378 Z M3.41222992,14.5362982 L5.84812168,16.9721898 L17.4721552,5.34815674 L15.0362635,2.91226508 L3.41222992,14.5362982 Z M15.5380031,2.41052545 L17.0919896,0.856539091 L19.5278354,3.29243075 L17.9738949,4.84637115 L15.5380031,2.41052545 Z"
          id="Shape"
          fill={fillColor}
          fillRule="nonzero"
        ></path>
      </g>
    </svg>
  );
};

export default PenIcon;
